import { render, staticRenderFns } from "./expert_box.vue?vue&type=template&id=59200c40&scoped=true"
import script from "./expert_box.vue?vue&type=script&lang=js"
export * from "./expert_box.vue?vue&type=script&lang=js"
import style0 from "./expert_box.vue?vue&type=style&index=0&id=59200c40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59200c40",
  null
  
)

export default component.exports